<main class="snackBar green " *ngIf="data.type=='success'">
    <div class="flex items-center space-x-4">
        <mat-icon>done</mat-icon>
        <p>{{data.message | translate}} </p>
    </div>
    <button (click)="closeSnackBar()">
        <mat-icon>close</mat-icon>
    </button>
</main>

<main class="snackBar yellow space-x-4" *ngIf="data.type=='warn'">
    <div class="flex items-center space-x-4">
        <mat-icon>warning</mat-icon>
        <p>{{data.message | translate}}</p>
    </div>
    <button (click)="closeSnackBar()">
        <mat-icon>close</mat-icon>
    </button>
</main>

<main class="snackBar red space-x-4" *ngIf="data.type=='error'">
    <div class="flex items-center space-x-4">
        <mat-icon>block</mat-icon>
        <p>{{data.message | translate}}</p>
    </div>
    <button (click)="closeSnackBar()">
        <mat-icon>close</mat-icon>
    </button>
</main>

<main class="snackBar neutral space-x-4" *ngIf="data.type=='info'">
    <div class="flex items-center space-x-4">
        <mat-icon>info</mat-icon>
        <p>{{data.message | translate}}</p>
    </div>
    <button (click)="closeSnackBar()">
        <mat-icon>close</mat-icon>
    </button>
</main>